module.exports = __webpack_public_path__ + "static/media/fire_truck.0e7ce5a4.png";